import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Configuracoes } from 'src/app/entities/configuracoes';
import { ConfiguracoesSite } from 'src/app/entities/configuracoesSite';
import { CartService } from 'src/app/services/cart-service';
import { PedidoService } from 'src/app/services/pedido-service';
import { ProductService } from 'src/app/services/product-service';
import { SecurityService } from 'src/app/services/security-service';
import { getOrderItemFromProduct } from '../shared/function';
import { ProductImageComponent } from '../product-image/product-image.component';
import { ToastrService } from "ngx-toastr";
import { ConfiguracoesMisc } from "src/app/entities/configuracoesMisc";

@Component({
  selector: 'app-catalog-item',
  templateUrl: './catalog-item.component.html',
  styleUrls: ['./catalog-item.component.css']
})
export class CatalogItemComponent implements OnInit {
  MISC: ConfiguracoesMisc;
  @Input()
  public product: any;

  @Input()
  public produtoColXL;

  @Input()
  public produtoHeight;

  @Input()
  public produtoDescrHeight;

  @Input()
  public produtoDescrFontSize;

  @Input()
  public produtoIndispFontSize;

  @Input()
  public produtoDescrLen;

  @Output()
  public redirectTo = new EventEmitter<number>();

  @ViewChild('productImage', { read: ProductImageComponent, static: true })
  public productImage!: ProductImageComponent;

  public showStock: boolean;
  public userLogged: boolean = false
  public validaEstoque: boolean;
  public pedido: any;
  public API_IMAGENS: String;
  public API_IMAGENS_PRODUTOS: String;
  public SITE: ConfiguracoesSite;
  public mostraPreco = false;
  public stock: string;
  public config: ConfiguracoesMisc
  constructor(
    public productService: ProductService,
    public securityService: SecurityService,
    public toastService: ToastrService,
    public pedidoService: PedidoService,
    public cartService: CartService
  ) {
    this.API_IMAGENS = Configuracoes.API_IMAGENS;
    this.API_IMAGENS_PRODUTOS = Configuracoes.API_IMAGENS_PRODUTOS;
    this.SITE = Configuracoes.SITE;
    this.config = Configuracoes.MISC;

    this.pedido = this.pedidoService.pedido;
    if (!this.securityService.hasToken() && !this.SITE.mostraPrecoLoginAtivo)
      this.mostraPreco = true;
    if (this.securityService.hasToken() && (!this.SITE.mostraPrecoPedidoSelecionado || this.pedido)) {
      this.mostraPreco = true;
    }

    if(this.securityService.hasToken() ){
      this.userLogged = true
    }
  }

  ngOnInit() {
    if (this.SITE.quantidadeMaximaGrade == false) {
      this.stock = `${this.product.estoque}`;
    } else if (this.product.estoque > this.SITE.quantidadeMaximaGrade) {
      this.stock = `+${this.SITE.quantidadeMaximaGrade}`;
    } else {
      this.stock = `${this.product.estoque}`;
    }

    if (this.pedido) {
      this.validaEstoque = this.pedido.tipo.validaEstoque;
    }
    // } else {
      this.showStock = this.SITE.mostraEstoqueDigitacao
    // }
  }

  public addCart(quantity: number) {
    this.updateQuantity(quantity);
    if (this.product.sku) {
      const tax = this.product.imposto;
      const price = this.product.precopromocional ? this.product.precopromocional : this.product.preco;

      let taxValue = null;
      let taxCalc = {};

      if (tax) {
        taxCalc = this.productService.calculaImposto(price, tax.ipi, tax.alicms, tax.substicms, tax.alicmsorigem, tax.fcpSt);
        taxValue = this.productService.calculaValorImposto(price, tax.ipi, tax.alicms, tax.substicms, tax.alicmsorigem, tax.fcpSt);
      }
      const item = getOrderItemFromProduct(this.product, taxCalc, tax, taxValue, this.pedidoService.pedido.clientes[0].cliente.id, quantity, quantity * this.getPrice());
      this.pedidoService.setCartItemsSku([item], (res) => this.doOnSuccess(res, [item]), res =>this.doOnError(res));
    }
  }

  public doOnSuccess(res, items) {
    // let response = {...res, itens: res.itens.map((r: any)=> ({...r, produtoreferencia: r.produtoReferencia}))}
    this.cartService.addItems(items);
    this.pedidoService.select(res);
  }

  public doOnError(res) {
    // let response = {...res, itens: res.itens.map((r: any)=> ({...r, produtoreferencia: r.produtoReferencia}))}
    this.updateQuantity(0)
    if(res.status === 400){
      this.toastService.error(
        JSON.parse(res._body).detail,
        "Produto",
        {
          positionClass: "toast-bottom-left",
        }
      )}
  }

  public getPrice() {
    let taxValue = 0;
    let tax: any = 0
    if(!this.SITE.mostraprecosemimposto){
      tax = this.product.imposto;
    }

    if (tax && !this.SITE.mostraprecosemimposto) {
      const price = this.product.precopromocional ? this.product.precopromocional : this.product.preco;
      taxValue = this.productService.calculaValorImposto(price, tax.ipi, tax.alicms, tax.substicms, tax.alicmsorigem, tax.fcpSt);
    }

    return this.product.preco + taxValue;
  }

  public updateQuantity(quantity) {
    this.product.quantidade = quantity;
    this.productImage.updateQuantity(quantity);
    this.ngOnInit();
  }
}
